<style lang="scss">
    .owl-dot {
        display: inline-block;
        zoom: 1;
        *display: inline;
        span {
            width: 10px;
            height: 10px;
            margin: 5px 7px;
            background: #747475;
            display: block;
            -webkit-backface-visibility: visible;
            transition: opacity 200ms ease;
            border-radius: 30px;
        }
        &.active {
            span {
                background: #8b21ac;
            }
        }
    }
</style>

<template>
    <div class="owl-carousel">
        <slot name="carousel-content"></slot>
    </div>
</template>

<script>
    import 'owl.carousel'

    export default {
        props: {
            items: {
                type: Number,
                default: 3
            },
            margin: {
                type: Number,
                default: 10
            },
            dots: {
                type: Boolean,
                default: true
            },
            nav: {
                type: Boolean,
                default: false
            },
            navText: {
                type: Array,
                default() {
                    return ['&#x27;next&#x27;','&#x27;prev&#x27;']
                }
            },
            autoplay: {
                type: Boolean,
                default: false
            },
            dotsContainer: {
                type: [String, Boolean],
                default: false
            },
            loop: {
                type: Boolean,
                default: false
            },
            responsive: {
                type: Object,
                default() {
                    return {}
                }
            },
            responsiveBaseElement: {
                default() {
                    return window
                }
            },
            stagePadding: {
                type: Number,
                default: 30
            }
        },
        data() {
            return {
                carousel: null
            }
        },
        mounted() {
            this.$nextTick(() => {
                let vm = this

                $(this.$el).owlCarousel({
                    items: vm.items,
                    margin: vm.margin,
                    dots: vm.dots,
                    dotsContainer: vm.dotsContainer,
                    nav: vm.nav,
                    navText: vm.navText,
                    autoplay: vm.autoplay,
                    loop: vm.loop,
                    responsive: vm.responsive,
                    responsiveBaseElement: vm.responsiveBaseElement,
                    stagePadding: vm.stagePadding
                })

                if (vm.dotsContainer) {
                    $(vm.dotsContainer).css({"text-align": "center", "-webkit-tap-highlight-color": "transparent"})
                    $(vm.dotsContainer + ".disabled").css("display", "none")
                }
            })

        },
        beforeDestroy() {
            if (this.carousel) {
                this.carousel.trigger("destroy.owl.carousel")
            }
        }
    }
</script>